<!-- 校本备课 -->

<template>
    <div class='page_content' v-loading="pageLoading">
        <div class="container">
            <div class="data_count">
                <span>班会总数量</span>
                <span class="num">{{ total || 0 }}</span>
            </div>
            <div class="tab_out_box">
                <div class="line_box">
                    <div class="label">分类：</div>
                    <div class="value_box">
                        <div v-for="(item, index) in cateArr" :key="index" :class="{ check: item.value == cateOne }"
                            class="value_item_box" @click="checkFirstType(item)">{{ item.name }}</div>
                    </div>
                </div>
                <div class="line_box" v-if="cateTowArr.length">
                    <div class="label"></div>
                    <div class="value_box gray">
                        <div v-for="(item, index) in cateTowArr" :key="index" :class="{ check: item.value == cateTwo }"
                            class="value_item_box" @click="cateTwo = item.value">{{ item.name }}</div>
                    </div>
                </div>
                <!-- <div class="line_box">
                    <div class="label">学科：</div>
                    <div class="value_box">
                        <div
                            v-for="(item, index) in schoolSubjectArr"
                            :key="index"
                            :class="{ check: item.value == school_subject_id }"
                            class="value_item_box"
                            @click="school_subject_id = item.value"
                        >{{ item.name }}</div>
                    </div>
                </div>
                <div class="line_box">
                    <div class="label">资源类型：</div>
                    <div class="value_box">
                        <div
                            v-for="(item, index) in courseArr"
                            :key="index"
                            :class="{ check: item.value == course }"
                            class="value_item_box"
                            @click="course = item.value"
                        >{{ item.name }}</div>
                    </div>
                </div> -->
            </div>
            <div class="bottom_out_box">
                <div class="ctn_box">
                    <div class="title">班会列表</div>
                    <div class="line_ctn" v-for="(item, index) in pageList" :key="index">
                        <!-- src="@/assets/images/2.png" -->
                        <!-- <img :src="item.head_image" class="icon"> -->
                        <img class="icon" v-bind:src="$getImageUrl(item.annex_file)" alt="" />

                        <div class="lb_ctn">
                            <div class="lbc_info_box" style="flex:1;">
                                <div class="lbc_title">{{ item.title }}</div>
                                <div class="lbc_desc_box">
                                    <!-- item.source_data_text -->
                                    <!-- <div class="lbcd_item">学科：{{ (item.school_subject || {}).name || "" }}</div> -->
                                    <div class="lbcd_item">类型：{{ item.class_meet_type == '1' ? "班会" : item.class_meet_type
                                        == '2' ? "家长会" :
                                        item.class_meet_type == '3' ? "班主任管理" : ""
                                    }} <span v-if="item.class_meet_type == '1'">
                                            ({{ item.class_meet_catgory == '1' ? "安全类" : item.class_meet_catgory
                                                == '2' ? "教育类" :
                                                item.class_meet_catgory == '3' ? "文化类" : ""
                                            }})
                                        </span>
                                    </div>

                                    <div class="lbcd_item">作者：{{ item.user.username }}</div>
                                    <div class="lbcd_item">上传时间：{{ item.createtime }}</div>
                                </div>
                            </div>
                            <div class="lbc_btns_box">
                                <div class="btn" @click="viewVideoHandle(item.annex_file)">预览</div>
                                <div class="btn red" @click="downVideo(item)" v-loading="item.downLoading">下载</div>
                                <div v-loading="item.collectLoading" class="collect"
                                    :class="{ check: item.is_folllow == 1 }" style="cursor:pointer;" @click="collect(item)">
                                    <img v-if="item.is_folllow == 1" src="@/assets/images/5.png" class="c_icon">
                                    <img v-else src="@/assets/images/6.png" class="c_icon">
                                    <p v-if="item.is_folllow == 1">收藏</p>
                                    <p v-else>收藏</p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <el-empty description="请查看其他章节信息" v-if="!pageLoading && !pageList.length"></el-empty>

                    <!-- fenye -->
                    <div v-if="total" class="fenye_box">
                        <pagination :page.sync="page" :pageSize.sync="pageSize" :total="total" @change="pageChange" />
                    </div>
                </div>
            </div>
        </div>

        <!-- 预览 -->
        <el-dialog title="视频预览" :visible.sync="showViewVideo">
            <!-- src="@/assets/demo.mp4" -->
            <video ref="video" :src="videoUrl" controls style="width:100%"></video>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '../../components/Pagination.vue'
import { XUEDUAN, COURSE_DATA, BANHUI_TYPE, MODE_TYPE, } from '@/const'
var _listTimer = null;
var _chapterTimer = null;
export default {
    components: { Pagination },
    data() {
        return {
            showViewVideo: false,
            videoUrl: "",
            period: XUEDUAN.DEFAULT, // 学段
            grade: 1,// 年级
            school_subject_id: "", // 学科
            course: COURSE_DATA.DEFAULT,// 资源类型
            xueduanArr: XUEDUAN.getArr(),
            courseArr: COURSE_DATA.getArr(),
            COURSE_DATA,
            schoolSubjectArr: [],
            pageLoading: true,
            chapterArr: [], // 章节信息
            danyuanId: "",
            chapterId: "",
            page: 1,
            pageSize: 10,
            total: 0,
            pageList: [],
            cateArr: BANHUI_TYPE.getArr(),
            cateTowArr: BANHUI_TYPE.getArr()[0].children,
            cateOne: BANHUI_TYPE.DEFAULT,
            cateTwo: BANHUI_TYPE.TOW_DEFAULT,
            keyword: ''
        }
    },
    computed: {
        /** 年级数据 */
        nianjiArr() { return this.xueduanArr.find(item => item.value == this.period).children || [] },
        /** 搜索内容 */
        topSearchKeywords() { return this.$store.state.topSearchKeywords }
    },
    watch: {
        showViewVideo(val) { val || this.$refs.video.pause(); },
        period(val) {
            if (val == XUEDUAN.XIAOXUE) this.grade = XUEDUAN.YINIANJI;
            if (val == XUEDUAN.CHUZHONG) this.grade = XUEDUAN.CHUYI;
            if (val == XUEDUAN.GAOZHONG) this.grade = XUEDUAN.GAOYI;
        },
        grade() { this.pageLoading = true; this.initPageCtn(); },
        cateOne() { this.pageLoading = true; this.initPageCtn(); },
        cateTwo() { this.pageLoading = true; this.initPageCtn(); },
        school_subject_id() { this.pageLoading = true; this.initPageCtn(); },
        course() { this.pageLoading = true; this.getPageCtn(); },
        chapterId() { this.getPageCtn(); },
        danyuanId() { this.getPageCtn(); },
    },
    mounted() {
        const query = this.$route.query;
        this.page = +query.page || 1;
        this.pageSize = +query.size || 10;
        this.getPageCtn();
        // this.getXueke();
        // this.eventBus.$on('updateYurenList', () => this.getPageCtn());
        this.eventBus.$on('updateYurenList', (res) => {
            this.keyword = res;
            this.getPageCtn()
        });
    },
    beforeDestroy() { this.eventBus.$off('updateYurenList') },
    methods: {
        // 选中类型
        checkFirstType(item) {
            // console.warn(item, "hhhh")
            this.cateTowArr = item.children;
            this.cateOne = item.value;
            this.cateTwo = (this.cateTowArr[0] || {}).value || 0;
        },
        // 下载视频
        downVideo(item = {}) {
            if (!item.annex_file) return this.$message.info('无效的下载链接')
            if (item.downLoading) return;
            item.downLoading = true;
            fetch(item.annex_file).then(res => res.blob()).then(blob => {
                const a = document.createElement('a');
                document.body.appendChild(a)
                a.style.display = 'none'
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = item.title;
                a.click();
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url);
                item.downLoading = false;
                const res = this.$get('school_source/download', {
                    id: item.id,
                })
                console.debug(res)
            }).catch(err => {
                item.downLoading = false;
                this.$message.error('下载fail，请稍后重试');
            })
        },
        /** 视频预览 */
        viewVideoHandle(url = "") {
            const isVideo = ['.rm', '.rmvb', '.wmv', '.asf', '.asx', '.mp4', '.3gp', '.mov', '.m4v', '.avi', '.dat', '.mkv', '.flv', '.vob',].some(item => ~url.indexOf(item));
            if (isVideo) {
                this.videoUrl = url;
                this.showViewVideo = true;
            } else window.open(url)
        },
        /** 分页改变 */
        pageChange() {
            this.$router.replace(`/home/beike?page=${this.page}&size=${this.pageSize}`);
            this.getPageCtn();
        },
        /** 改变章节 */
        changeChapter(danyuanId = "", chapterId = "") {
            this.chapterId = chapterId
            this.danyuanId = danyuanId
        },
        /** 初始化页面数据 */
        initPageCtn() {
            // this.getChapter();
            this.getPageCtn();
        },
        /** 获取章节数据 */
        getChapter() {
            clearTimeout(_chapterTimer)
            _chapterTimer = setTimeout(async () => {
                const res = await this.$get('school_source/getUnitChapter', {
                    school_subject_id: this.school_subject_id
                });
                this.chapterArr = (res.data.data || []).map(item => {
                    return {
                        ...item, value: item.id, children: (item.school_chapter || []).map(item => {
                            return { ...item, name: item.chapter_name, value: item.id }
                        })
                    }
                });
            }, 50);
        },
        // 获取学科
        async getXueke() {
            const res = await this.$get('school_source/getSchoolSubject', {
                period: this.period,
                grade: this.grade,
            })
            this.schoolSubjectArr = (res.data || []).map(item => {
                return { ...item, value: item.id }
            });
            this.school_subject_id = this.schoolSubjectArr[0].value;
            this.initPageCtn();
        },
        /** 获取内容 */
        getPageCtn() {
            clearTimeout(_listTimer)
            this.pageLoading = true;
            // if (this.cateOne == "1") {
            //     this.cateOne = ''
            // }
            // if (this.cateTwo == "1") {
            //     this.cateTwo = ''
            // }
            _listTimer = setTimeout(async () => {
                try {
                    const res = await this.$post('school_source/index', {
                        // type_data: 3,
                        // period: this.period,
                        // grade: this.grade,
                        // school_subject_id: this.school_subject_id,
                        // source_data: this.course,
                        // school_unit_id: this.danyuanId,
                        // school_chapter_id: this.chapterId,
                        pageNum: this.page,
                        pageSize: this.pageSize,
                        class_meet_catgory: this.cateTwo,//班会分类
                        class_meet_type: this.cateOne,//班会类型
                        type_data: MODE_TYPE.BANHUI,
                        kwd: this.keyword,
                    })
                    this.pageList = (res.data.data || []).map(item => {
                        return { ...item, downLoading: false, collectLoading: false }
                    });
                    this.total = res.data.total || 0;
                } catch (error) { }
                this.pageLoading = false;
            }, 50);
        },
        /** 进行收藏 */
        async collect(item) {
            if (item.collectLoading) return;
            item.collectLoading = true;
            try {
                const res = await this.$post('person_center/follow', { id: item.id });
                if (item.is_folllow == 1) item.is_folllow = 2;
                else item.is_folllow = 1;
            } catch (error) { }
            item.collectLoading = false;
        },
    },
}
</script>

<style lang='scss' scoped>
.page_content {
    min-height: 100%;
    height: 100%;
    background-color: #f5f7f9;
    padding-bottom: 32px;
    font-family: PingFang SC, PingFang SC-Regular;
}

.data_count {
    padding: 26px 0 20px;
    font-size: 16px;
    color: #999999;
    display: flex;
    align-items: center;

    .num {
        font-size: 22px;
        font-weight: 700;
        color: #333;
        margin-left: 8px;
    }
}

.tab_out_box {
    margin-bottom: 16px;
    background-color: #fff;
    border-top: 4px solid #d9242a;
    padding: 1px 0 30px;

    .line_box {
        display: flex;
        // align-items: center;

        .label {
            width: 114px;
            height: 32px;
            text-align: right;
            flex-shrink: 0;
            margin-top: 28px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }

        .value_box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            &.gray .value_item_box {
                color: #999;
            }

            .value_item_box {
                min-width: 64px;
                height: 32px;
                border-radius: 4px;
                box-sizing: border-box;
                padding: 0 8px;
                margin-top: 28px;
                margin-right: 24px;
                font-size: 16px;
                color: #333;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &.check {
                    color: #fff;
                    background: #d9242a;
                }
            }
        }
    }
}

.bottom_out_box {
    min-height: 100px;
    display: flex;
    align-items: stretch;
    color: #333;

    .check {
        color: #d9242a;
    }

    .cate_box {
        width: 300px;
        flex-shrink: 0;
        margin-right: 16px;
        box-sizing: border-box;
        padding: 12px 18px 32px 28px;
        font-family: PingFang SC, PingFang SC-Heavy;
        background-color: #fff;

        .title {
            font-size: 22px;
            font-weight: 800;
            color: #d9242a;
            line-height: 34px;
            padding: 20px 0 18px;
            border-bottom: 1px solid #e1e1e1;
        }

        .title2 {
            font-size: 22px;
            font-weight: 800;
            line-height: 34px;
            padding: 20px 0 18px;
        }

        .line_box {
            margin-bottom: 12px;
            display: flex;
            align-items: center;

            .dit {
                width: 43px;
                box-sizing: border-box;
                padding: 0 8px 0 0;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .d_ctn {
                    width: 8px;
                    height: 8px;
                    background: #dfdfdf;
                    border-radius: 50%;
                }
            }

            .lb_ctn {
                font-size: 16px;
                font-family: PingFang SC, PingFang SC-Regular;
                font-weight: 400;
                // color: #333333;
                line-height: 22px;
            }
        }
    }

    .ctn_box {
        flex: 1;
        background: #fff;
        box-sizing: border-box;
        padding: 30px 20px;

        .title {
            font-size: 24px;
            font-family: PingFang SC, PingFang SC-Heavy;
            font-weight: 800;
            text-align: left;
            color: #333333;
            line-height: 34px;
        }

        .fenye_box {
            margin-top: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .line_ctn {
            padding: 30px 0 28px;
            border-bottom: 1px solid #e1e1e1;
            display: flex;
            align-items: flex-start;

            &:last-of-type {
                border: none;
            }

            .icon {
                width: 72px;
                height: 72px;
                margin-right: 28px;
                margin-top: 3px;
                flex-shrink: 0;
            }

            .lb_ctn {
                flex: 1;
                display: flex;
                align-items: center;

                .lbc_info_box {
                    .lbc_title {
                        font-size: 16px;
                        font-family: '幼圆';
                        // font-weight: 800;
                        text-align: left;
                        color: #333333;
                        line-height: 34px;
                        margin-bottom: 3px;
                    }

                    .lbc_desc_box {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;

                        .lbcd_item {
                            font-size: 14px;
                            margin-top: 5px;
                            margin-right: 25px;
                        }
                    }
                }

                .lbc_btns_box {
                    display: flex;
                    align-items: center;
                    margin-left: 32px;

                    .btn {
                        width: 64px;
                        height: 32px;
                        background: #efefef;
                        border: 1px solid #e1e1e1;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #666666;
                        margin-right: 16px;

                        &.red {
                            background: #d9242a;
                            color: #ffffff;
                            margin-right: 32px;
                        }
                    }

                    .collect {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        font-size: 14px;
                        font-family: PingFang SC, PingFang SC-Regular;
                        font-weight: 400;
                        text-align: left;
                        white-space: nowrap;
                        color: #999999;

                        .c_icon {
                            width: 24px;
                            height: 24px;
                            margin-bottom: 2px;
                        }

                        &.check {
                            color: #d9242a;
                        }
                    }
                }
            }
        }
    }
}

.cur {
    cursor: pointer;
}
</style>
